import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { VitalHttpServices } from './VitalHttpServices';

@Injectable({
  providedIn: 'root'
})
export class SuppressionService {
  constructor(private readonly http: HttpClient, private readonly vitalHttpServices: VitalHttpServices) {}

  removeEmail(email: string): Observable<any> {
    const url = `${this.vitalHttpServices.baseUrl2}api/suppressions/remove`;
    return this.http.request<any>('post', url, {
      body: { email }
    });
  }
}
